export default __webpack_public_path__ + "static/media/dollarhedge-graph.75077263.png";